import { responsiveStyle } from '@synoptic/ui-kit/responsive/responsive-style.ts';
import { themeVars } from '@synoptic/ui-kit/theme/vars.ts';
import { space } from '@synoptic/ui-kit/tokens.js';
import { style } from '@vanilla-extract/css';

export const newPostForm = style({
  display: 'flex',
  flexDirection: 'column',

  selectors: {
    '&[data-drag-over]': {
      outline: `2px dashed ${themeVars.color.border.primary}`,
      outlineOffset: '4px',
    },
  },
});

export const newPostActions = style([
  {
    display: 'flex',
    width: '100%',
    marginTop: space.s24,
  },
  responsiveStyle({
    mobile: {
      flexDirection: 'column',
      alignItems: 'start',
    },
    tablet: {
      flexDirection: 'row',
      justifyContent: 'space-between',
      alignItems: 'center',
    },
  }),
]);

export const newPostActionsRow = style({
  display: 'flex',
  width: '100%',
});

export const newPostActionsSubmitButton = style({
  ...responsiveStyle({
    mobile: {
      width: '100%',
      marginTop: space.s32,
    },
    tablet: {
      width: '120px',
      flexShrink: 0,
      marginTop: 0,
    },
  }),
});

export const formImgSection = style({
  display: 'flex',
  gap: space.s8,
});

export const newPostContentContainer = style({
  display: 'flex',
});

export const newPostContent = style({
  display: 'flex',
  width: '100%',
  flexDirection: 'column',
  gap: space.s24,
});
